import { render, staticRenderFns } from "./OrderAdmittanceWorks.vue?vue&type=template&id=4680f37a&scoped=true&"
import script from "./OrderAdmittanceWorks.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680f37a",
  null
  
)

export default component.exports
import {QItem,QInput} from 'quasar'
component.options.components = Object.assign({QItem,QInput}, component.options.components || {})
